import {connect} from 'react-redux';
import OverlappingSearchFormChart from '../components/component/btn_OverlappingSearchFormChart';
import {bindActionCreators} from 'redux';
import {selectActiveData} from '../action/index';


function mapDispatchToProps(dispatch, ownProps) {
  return bindActionCreators({selectActiveData: selectActiveData}, dispatch)
}

export default connect(null, mapDispatchToProps)(OverlappingSearchFormChart);



// WEBPACK FOOTER //
// ./src/containers/cont_OverlappingSearchForm.js